

import MyShow from "../data/MyShow";

export default {
    _MyShow:MyShow,
};